import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import { t } from '../../../../../../i18n';
import { sendRequest } from '../../../../../../helpers/saga';
import { logger } from '../../../../../../helpers/logger';
import jobActions from '../../../actions';
import notifications from '../../../../../../redux/notifications/actions';
import Api from '../../../../../../helpers/api';
import attentionRequiredActions from '../../../attentionRequired/actions';

const formDataApi = new Api('shifts/:id/work_hours_adjustments/form_data');
const approveApi = new Api('shifts/:id/work_hours_adjustments/approve');
const declineApi = new Api('shifts/:id/work_hours_adjustments/decline');
const changeTimingsApi = new Api('shifts/:id/work_hours_adjustments/change_timings');

function* loadFormData({ payload }) {
  try {
    const { id } = payload;

    const result = yield call(sendRequest, formDataApi.load, { id }, notifications.REQUEST_ERROR);

    if (result?.data?.success?.data) {
      yield put(actions.loadFormDataSuccess(result.data.success.data));
    }
  } catch (error) {
    logger.error(error);
  }
}

function* approve({ payload }) {
  try {
    const { id, cb, jobId } = payload;

    const result = yield call(
      sendRequest,
      approveApi.multipleParamsCreateItem,
      {
        params: { id },
        data: {
          work_hours_adjustment: { responder_notes: '' },
        },
      },
      notifications.REQUEST_ERROR,
    );

    if (result) {
      yield put(jobActions.loadData({ id: jobId }));
      yield put(actions.hideModal());
      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.success_headline'),
          type: 'success',
          message: t('dash.common.notification.approved_successfully', {
            item: t('dash.jobs.attentionRequiredSection.timings_label'),
          }),
        }),
      );
    }

    if (cb) {
      cb();
    }
  } catch (error) {
    logger.error(error);
  }
}

function* decline({ payload }) {
  try {
    const { id, cb, jobId } = payload;

    const result = yield call(
      sendRequest,
      declineApi.multipleParamsCreateItem,
      {
        params: { id },
        data: {
          work_hours_adjustment: { responder_notes: '' },
        },
      },
      notifications.REQUEST_ERROR,
    );

    if (result) {
      yield put(jobActions.loadData({ id: jobId }));
      yield put(actions.hideModal());
      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.success_headline'),
          type: 'success',
          message: t('dash.common.notification.declined_successfully', {
            item: t('dash.jobs.attentionRequiredSection.timings_label'),
          }),
        }),
      );
    }

    if (cb) {
      cb();
    }
  } catch (error) {
    logger.error(error);
  }
}

function* changeTimings({ payload }) {
  try {
    const { id, data, cb, jobId } = payload;

    const result = yield call(
      sendRequest,
      changeTimingsApi.multipleParamsCreateItem,
      {
        params: { id },
        data,
      },
      notifications.REQUEST_ERROR,
    );

    if (result) {
      yield put(jobActions.loadData({ id: jobId }));
      yield put(actions.hideModal());
      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.success_headline'),
          type: 'success',
          message: t('dash.common.notification.requested_successfully', {
            item: t('dash.jobs.attentionRequiredSection.changes_label'),
          }),
        }),
      );
      yield put(attentionRequiredActions.loadResolvedData({ id: jobId }));
      yield put(attentionRequiredActions.loadOutstandingData({ id: jobId }));
    }

    if (cb) {
      cb();
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.SHOW_MODAL, loadFormData),
    takeEvery(actions.APPROVE, approve),
    takeEvery(actions.DECLINE, decline),
    takeEvery(actions.CHANGE_TIMINGS, changeTimings),
  ]);
}
